import React from "react";

const VimeoVideo = () => {
  return (
    <div
      style={{
        height: "100%", width: "100%"
      }}
    >
      <iframe
        src="https://vimeo.com/event/541082/embed"
        frameBorder="0"
        allow="autoplay"
        allowFullScreen
        style={{
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
        }}
        title="vimeo_video"
      />
    </div>
  );
};

export default VimeoVideo;
